import 'css-chunksrc/client/scenes/calendar/weeklyView/timeView/task/styles.scss';export default {
  "taskWrapper": "_taskWrapper_17864_1",
  "task": "_task_17864_1",
  "background": "_background_17864_23",
  "leftBorder": "_leftBorder_17864_33",
  "main": "_main_17864_42",
  "short": "_short_17864_53",
  "name": "_name_17864_58",
  "time": "_time_17864_77",
  "icon": "_icon_17864_84",
  "taskIcon": "_taskIcon_17864_94",
  "taskIconCompleted": "_taskIconCompleted_17864_98",
  "taskPopupMain": "_taskPopupMain_17864_102"
};